module.exports={
    // 登录页
    sjhm: 'номер телефона',
    qsrdxyzm:'Введите SMS-код',
    fsyzm:'Отправить код',
    login:'Вход',
    yIDhmmdl:'Вход по ID и паролю',
    qsrID:'Введите ID',
    qsrmm:'Введите пароль',
    ysjhmdl:'Вход по номеру телефона',
    xzsq:'Выберите сообщество',
    zhmmcw:'Ошибка аккаунта или пароля',
    zc:'Регистрация',
    zhmm:'Сброс пароля',
    qsrsjhm:'Введите номер телефона',
    mhzxhq:'сек, повторить',
    hqyzmsb:'Ошибка получения кода!',
    sbbczhmqx:'Устройство не существует или нет прав!',
    ryzc:'Регистрация персонала',
    sfz:'ID карта',
    hz:'Паспорт',
    jzz:'Вид на жительство',
    jsz:'Водительские права',
    nbool:'Мужской',
    ngril:'Женский',
    qxkmmm:'Введите пароль открытия!',
    qxgh:'Введите номер сотрудника!',
    scgg:'Загрузка успешна',
    scsb:'Ошибка загрузки',
    tpgxsb:'Ошибка обновления изображения',
    xlh:'Серийный номер',
    wsh:'Не проверено',
    ysh:'Проверено',
    rq:'Дата',
    cd:'Опоздание',
    jb:'Переработка',
    zat:'Ранний уход',
    qtxbt:'Введите заголовок',
    qtxnr:'Введите содержание',
    ysdfkgx:'Спасибо за ваш отзыв!',
    fksb:'Ошибка отправки',
    lya:'Открыть Bluetooth',
    ss:'Поиск',
    lykm:'Bluetooth открытие',
    cx:'Запрос',
    yc:'Один раз',
    lc:'Два раза',
    zx:'Онлайн',
    lx:'Офлайн',
    kmen:'Открыть',

    // 首页
    yckm:'Удалённое открытие',
    fkyy:'Запись гостя',
    fxys:'Поделиться ключом',
    ewmkm:'QR код открытие',
    smkm:'Сканирование открытия',
    yjkm:'Одно касание',
    sy:'Главная',
    zzzc:'Самостоятельная регистрация',
    sb:'Устройство',
    wd:'Мой',
    cw:'Ошибка',
    // 远程开门页面
    sbmhzwz:'Имя или местоположение устройства',
    cxwz:'Запрос местоположения',
    sbwz:'Местоположение устройства',
    zt:'Статус',
    km:'Открыть',
    kmcg:'Дверь открыта',
    kmsb:'Ошибка открытия',
    // 访客预约页面
    xm:'Имя',
    rlzp:'Фото лица',
    tj:'Добавить',
    zjlx:'Тип документа',
    zjh:'Номер документа',
    xb:'Пол',
    sfcs:'Провинция/Город',
    sxrs:'Количество сопровождающих',
    syo:'Причина',
    fwyxq:'Срок действия визита',
    bfrhm:'Номер принимающего',
    bfrxm:'Имя принимающего',
    tjyy:'Отправить запись',
    // 分享钥匙页面
    sssb:'Поиск устройства',
    xzsb:'Выбрать устройство',
    wsb:'Нет устройства',
    fwcs:'Количество визитов',
    bxcs:"Без ограничений",
    qjzewmdzjt:'(Наведите QR код на камеру)',
    fxewm:'Создать QR код',
    fxmm:'Поделиться паролем',
    // 自主注册页面
    jg:'Место происхождения',
    hj:'Постоянное место',
    qybm:'Отдел компании',
    kh:'Номер карты',
    kmmm:'Пароль открытия',
    gh:'Номер сотрудника',
    qd:'Подтвердить',
    qtxsjhm:'Введите номер телефона',
    qtxxm:'Введите имя',
    qxzbm:'Выберите отдел',
    qszkmmm:'Установите пароль открытия',
    qtxgh:'Введите номер сотрудника',
    zccg:'Регистрация успешна',
    zcsb:'Ошибка регистрации',
    // 我的页面
    txjl:'Запись доступа',
    fkjl:'Запись гостя',
    kqrb:'Ежедневная посещаемость',
    fkwm:'Обратная связь',
    tcdl:'Выйти',
    // 通行记录页面
    txsj:'Время доступа',
    kmlx:'Тип открытия',
    // 反馈我们页面
    lfsj:'Время визита',
    shzt:'Статус проверки',
    mygd:'Больше нет',
    bt:'Заголовок',
    qsrbt:'Введите заголовок',
    ly:'Сообщение',
    qsrly:'Введите сообщение',
    tjfk:'Отправить отзыв',
    zhxx:'Информация о аккаунте',
    sfqdtc:'Вы уверены, что хотите выйти?',
    qx:'Отмена',
    // 设备搜索页面
    sbss:'Поиск устройства',
    kysb:'Доступные устройства',
    ssjg:'Результаты поиска',
    sbtj:'Добавить устройство',
    sblx:'Тип устройства',
    sfwzcj:'Является ли регистратором',
    qxz:'Выберите',
    azwz:'Место установки',
    kmzt:'Статус двери',
    wifimm:'WiFi пароль',

    // 设备设置页面
    wlgl:'Управление сетью',
    yggl:'Управление персоналом',
    qxfp:'Распределение прав',
    gxqx:'Обновить права',
    cqsb:'Перезагрузить устройство',
    cshsb:'Инициализировать устройство',
    scsb:'Удалить устройство',
    cshPopTips:'Текущая операция удалит все права пользователей, а затем загрузит все права пользователей.',
    qjscz:'Пожалуйста, действуйте осторожно!',
    qrgxqxm:'Подтвердите обновление прав?',
    qrcqsbm:'Подтвердите перезагрузку устройства?',
    dqczjscsb:'Текущая операция удалит устройство.',
    shgl:'Управление проверкой',
    bmgl:'Управление отделом',
    rygl:'Управление персоналом',
    ts:'Подсказка',
    sbsccg:'Устройство успешно удалено',
    sbbcz:'Устройство не существует',
    sbyc:'Устройство не в сети, проверьте подключение',
    mqxhzhmmcw:'Нет прав или неверный пароль',
    gxqxsb:'Ошибка обновления прав, код ошибки',
    gxqxcg:'Права успешно обновлены',
    sfyzgq:'Срок авторизации истёк, войдите снова',
    qsryhmm:'Введите пароль пользователя',
    qcsbcg:'Устройство успешно очищено',
    mmcw:'Неверный пароль',
    sbbzxhyc:'Устройство не в сети или неисправно',
    // 网络管理页面
    czsb:'Найти устройства',
    wifisz:'Настройки WiFi',
    qsrSSID:'Введите SSID',
    ytwsz:'Настройки Ethernet',
    DHCPms:'Режим DHCP',
    IPdz:'IP адрес',
    zwym:'Маска подсети',
    wg:'Шлюз',
    qsrIP:'Введите IP',
    qsrMASK:'Введите MASK',
    qsrGATEWAY:'Введите GATEWAY',
    sgsz:'Настройки 4G',
    tjxg:'Подтвердить изменения',
    qxljsb:'Сначала подключите устройство',
    qxzms:'Выберите режим',
    bnwk:'Не может быть пустым',
    wificsszcg:'WiFi параметры установлены',
    wifiszsbcwm:'Ошибка настройки WiFi, код ошибки',
    mmszsb:'Ошибка установки пароля',
    szwlmssb:'Ошибка установки сетевого режима',
    ipdzbnwk:'IP адрес не может быть пустым',
    ytwcsszcg:'Параметры Ethernet установлены',
    ytwcsszsb:'Ошибка установки параметров Ethernet',
    kqcg:'Успешно открыто',
    gbcg:'Успешно закрыто',
    kqsb:'Ошибка открытия',
   opentips:'Ошибка open! Если ошибка повторяется, переподключите устройство',

    sbtjcgzzszwifics:'Устройство добавлено, настраиваются параметры WiFi',
    sbtjcg:'Устройство успешно добавлено',
    zzcxpzwifi:'Перенастройка WiFi',
    sbycz:'Устройство уже существует',
    tjsbsb:'Ошибка добавления устройства',
    // 部门管理
    gm:'Переименовать',
    sc:'Удалить',
    xgcg:'Успешно изменено',
    bmbcz:'Отдел не существует',
    myqxhzhcw:'Нет прав или ошибка аккаунта',
    sbhryygl:'Устройство или персонал уже связаны, сначала очистите связь',
    tjcg:'Успешно добавлено',
    yczgwj:'Файл уже существует',
    gjdbnbcz:'Этот узел не может быть обработан',
    bmsc:'Удаление отдела',
    xgmc:'Изменить название',
    tjdbmmc:'Название добавляемого отдела',
    tjzbm:'Добавить подотдел',
    // 人员管理页面
    bm:'Отдел',
    wsp:'Не одобрено',
    rlwzc:'Лицо не зарегистрировано',
    rlbfmzc:'Частичная регистрация лица',
    rlzcsb:'Ошибка регистрации лица',
    xg:'Изменить',
    sccg:'Успешно удалено',
    rybcz:'Персонал не существует',
    // 人员添加页面
    tjry:'Добавить персонал',
    yhxm:'Имя пользователя',
    qsryhxm:'Введите имя пользователя',
    zjhm:'Номер документа',
    bmxz:'Выбор отдела',
    yxkssj:'Дата начала',
    xzrq:'Выбрать дату',
    yxjssj:'Дата окончания',
    sztx:'Установить аватар',
    bc:'Сохранить',
    qxzxb:'Выберите пол',
    qsrzjh:'Введите номер документа',
    qsrkh:'Введите номер карты',
    qsrgh:'Введите номер сотрудника',
    qsrkmmm:'Введите пароль открытия',
    qsryxkssj:'Введите дату начала',
    qsryxjssj:'Введите дату окончания',
    ryycz:'Персонал уже существует',
    khycz:'Номер карты уже существует',
    zcsbbcz:'Зарегистрированное устройство не существует',
    ghycz:'Номер сотрудника уже существует',
    // 人员修改
    xgryzl:'Изменить данные персонала',
    khbcz:'Номер карты не существует',
    sbcwm:'Ошибка! Код ошибки',
    ryxxhqsb:'Ошибка получения информации о персонале',
    // 权限分配
    sqzt:'Статус авторизации',
    wx:'Недействительно',
    yx:'Действительно',
    tbzt:'Статус синхронизации',
    wtb:'Не синхронизировано',
    rlwtb:'Лицо не синхронизировано',
    kwtb:'Карта не синхронизирована',
    sbmmwtb:'Пароль устройства не синхронизирован',
    tb:'Синхронизация',
    xz:'Выбрать',
    qxqx:'Выбрать все',
    sq:'Авторизовать',
    qxzsb:'Выберите устройство',
    qr:'Подтвердить',
    qxzsqsb:'Выберите авторизованное устройство',
    bftbsb:'Частичная ошибка синхронизации',
    qcktbzt:'Проверьте статус синхронизации',
    tbsbqcs:'Ошибка синхронизации, попробуйте ещё раз',
    bfscsb:'Частичная ошибка удаления',
    scsbqcs:'Ошибка удаления, попробуйте ещё раз',
    tjmk:'Добавить карту',
    rysc:'Удалить персонал',
    cg:'Успешно',
    删除成功:'Успешно удалено',
    授权成功:'Успешная авторизация',

    //再次新加
    sygx1:'Свободно отметьте 1',
    qrmm:'Подтвердите пароль',
    zhmmyx:'Email для сброса пароля',
    zzhmm:'Восстановить пароль',
    yxyzm:'Код из email',
    hqyxyzm:'Получить код из email',
    dt:'Считыватель',
    mj:'Контроль доступа',
    jin:'Вход',
    chu:'Выход',
    yes:'Да',
    no:'Нет',
    ysdyy:'Это первая страница',
    syy:'Назад',
    xyy:'Далее',
    rmcs:'Популярные города',
    xzgjhdq:'Выберите страну или регион',
    zhhyzmcw:'Ошибка аккаунта или кода',
    zhhmmcw:'Неверный аккаунт или пароль',
    xyhzc:'Новая регистрация',
    yhm:'Имя пользователя',
    qymc:'Название компании',
    yx:'Действителен',
    qsryx:'Введите email',
    yzms:'Код проверки',
    qsryxyzm:'Введите код из email',
    yxyzm:'Неверный код из email!',
    yzmbzq:'Неверный код',
    qsryhm:'Введите имя пользователя',
    hqyzmcg:'Код успешно получен!',
    yhycz:'Пользователь уже существует',
    mm:'Пароль',
    xmm:'Новый пароль',
    xgmm:'Изменить пароль',
    jmm:'Старый пароль',
    bf:'Посещение',
    qt:'Переговоры',
    yycg:'Запись успешна',
    yysb:'Ошибка записи',
    bfrbcz:'Посещаемый не существует',
    fkmhsjhmycz:'Посетитель или номер телефона уже существуют',
    mqtczsb:'Ошибка операции MQTT',
    ljfghy:'Поделиться с друзьями',
    fzlj:'Копировать ссылку',
    bnzydqsj:'Нельзя раньше текущего времени',
    yxqbn:'Срок не более 7 дней',
    rqxz:'Дата',
    szcg:'Успешно настроено',
    szsb:'Ошибка настройки',
    yhbcz:'Пользователь не существует',

    khkm:'Открыть картой',
    mmkm:'Открыть паролем',
    zwkm:'Открыть отпечатком',
    rlkm:'Открыть по лицу',

    // 手机号国家区
    zgdl:'Китай (материк)',
    zgxg:'Гонконг',
    zgam:'Макао',
    zgtw:'Тайвань',
    afh:'Афганистан',
    ade:'Андорра',
    agt:'Аргентина',
    ymny:'Армения',
    alb:'Аруба',
    adl:'Австрия',
    asbj:'Азербайджан',

    bhm:'Багамы',
    bl:'Бахрейн',
    bbds:'Барбадос',
    bjst:'Пакистан',
    bx:'Бразилия',
    bels:'Беларусь',
    bls:'Бельгия',

    cxx:'КНДР',
    cdjny:'Экваториальная Гвинея',
    dg:'Германия',
    dm:'Дания',
    jbt:'Джибути',
    dmnjghg:'Доминиканская Республика',
    els:'Россия',
    egde:'Эквадор',
    aj:'Египет',
    aseby:'Эфиопия',

    fg:'Франция',
    fl:'Финляндия',
    flb:'Филиппины',
    fdg:'Ватикан',

    gby:'Гамбия',
    ggghg:'Республика Конго',
    glby:'Колумбия',
    gb:'Куба',
    hg:'Республика Корея',
    hl:'Нидерланды',
    hd:'Гаити',

    jbz:'Камбоджа',
    jlbs:'Кирибати',
    jny:'Гвинея',
    jbbw:'Зимбабве',
    kml:'Камерун',
    kmqt:'Каймановы острова',
    kny:'Кения',
    kwt:'Кувейт',
    kldy:'Хорватия',
    lys:'Лаос',
    lby:'Ливия',
    lwd:'Руанда',
    mg:'США',
    mlxy:'Малайзия',
    mxg:'Мексика',
    nf:'Южная Африка',
    nbe:'Непал',
    nrly:'Нигерия',
    nw:'Норвегия',
    plqd:'Палау',
    pty:'Португалия',
    rb:'Япония',
    rd:'Швеция',
    rs:'Швейцария',
    stalb:'Саудовская Аравия',
    sd:'Судан',
    slxy:'Сент-Люсия',
    tgs:'Таиланд',
    tjs:'Тонга',
    teq:'Турция',
    wnrl:'Венесуэла',
    wl:'Бруней',
    wkl:'Украина',
    xxl:'Новая Зеландия',
    xjb:'Сингапур',
    xby:'Испания',
    xl:'Греция',
    xyl:'Венгрия',
    ydl:'Италия',
    yg:'Великобритания',
    ydnxy:'Индонезия',
    yd:'Индия',
    yn:'Вьетнам',
    ylk:'Ирак',
    zl:'Чили',
    zfghg:'Центральноафриканская Республика',

    wz:'Местоположение',
    lym:'Bluetooth',
    kmcg:'Дверь открыта',
    kmsb:'Ошибка открытия двери',
    qxdkly:'Сначала включите Bluetooth',
    手机号码在同一个公司已存在:'Номер телефона уже существует в компании',
    有效期要大于当前时间:'Срок должен быть больше текущего времени',
    请选择部门:'Выберите отдел',
    生成成功:'Успешно создано',
    长按二维码下载:'Долгое нажатие для скачивания QR-кода',
    摄像头权限被拒绝:'Разрешение на использование камеры отклонено',
    请先打开摄像头:'Сначала откроите камеру',
    请在浏览器设置中开启摄像头权限:'Пожалуйста, включите разрешение на использование камеры в настройках браузера',
    知道了:'Я знаю',
    加载中:'Загрузка...',
    应用不支持蓝牙功能:'Приложение Telegram не поддерживает функцию Bluetooth. Для нормального использования Bluetooth - функции будут включены в браузере Google - Chrome',
    // 浏览器中打开蓝牙功能:'Пожалуйста, включите Bluetooth в настройках браузера',
    // 复制链接:'Копировать ссылку',
    中打开:'Открыть в браузере',
    暂无部门:'Нет отделов',
    链接已复制:'Ссылка скопирована',
    返回:'Вернуться',
    请将二维码对准摄像头:'Пожалуйста, выровните QR-код с камерой',


    免审参数:'Параметры без проверки',
    自动授权截止时间:'Время истечения автоматического авторизации',
    请选择日期:'Пожалуйста, выберите дату',
    自动授权口令:'Пароль автоматического авторизации',
    请输入口令:'Пожалуйста, введите пароль',
    自动授权开关:'Переключатель автоматического авторизации',
    选择日期:'Выбрать дату',
   }
